/*
 * @Date: 2025-04-01 17:52:01
 * @Description:终端支付管理
 */
import TerminalPay from '../views/terminal-pay.vue';

export const route = [
  {
    path: '/main/asp/terminal-pay',
    name: 'asp-terminal-pay',
    meta: {
      title: '终端支付管理'
    },
    component: TerminalPay
  }
];
